<template>
  <!-- 上传记录 author: zhangxiaofeng-->
  <router-view :module="module"></router-view>
</template>
<script>
export default {
  name: 'Upload',
  data: () => {
    return {
      module: ''
    }
  },
  components: {},
  watch: {
    $route (to, from) {
      let _self = this
      _self.module = to.path
    }
  }
}
</script>
<style lang="less" type="text/less">
.upload-history {
  .table-body-wrapper {
    top: -47px !important;
  }
  .table-head-wrapper .table-head th {
    height: 41px !important;
  }
  .upload-table-wrapper {
    height: 100%;
    overflow: hidden;
    &.pagination {
      height: calc(100% - 32px);
    }
  }
  .icon_GTB4,
  .icon_GZB4 {
    background-image: url(~@/assets/images/project/jl-gbq-4.png);
    background-position: 0 0 !important;
  }
  padding: 24px;
  color: #333;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
  table {
    table-layout: fixed;
    word-break: break-all;
  }
  .table-body-wrapper tr {
    height: 46px;
    word-wrap: break-word;
    word-break: break-all;
  }
  .name-td {
    position: relative;
    .name-div {
      white-space: nowrap;
      overflow: hidden;
      padding-right: 25px;
      display: inline-block;
      max-width: 100%;
      text-overflow: ellipsis;
      position: relative;
      height: 20px;
      line-height: 20px;
      cursor: default;
      .upload-new {
        background: transparent url(~@/assets/images/upload-new.png) no-repeat;
        width: 20px;
        height: 20px;
        display: inline-block;
        position: absolute;
        top: 5px;
        margin-left: 3px;
        right: 0px;
      }
    }
  }
  .font-left {
    text-align: left;
    .file-icons {
      margin: 0;
    }
    .file-icons-null {
      display: inline-block;
      width: 32px;
      height: 32px;
    }
  }
  .empty-box {
    position: absolute;
    top: 0px;
    text-align: center;
    width: 100%;
    left: 0px;
    font-size: 26px;
    color: #999;
  }
  .errmsg-project {
    color: #d6d6d6;
  }
  .font-red {
    color: #ff7f00;
  }
  a.error-msg {
    color: blue;
  }
  a.error-msg:hover {
    text-decoration: underline;
  }
}
</style>
